if (!customElements.get('sticky-atc')) {
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.mainButton = document.querySelector('[id^="ProductSubmitButton-"]');
      this.button = this.querySelector('[data-sticky-button]');
      this.image = this.querySelector('[data-sticky-image]');
      this.color = this.querySelector('[data-sticky-color]');
      this.price = this.querySelector('[data-sticky-price]');
      this.compare = this.querySelector('[data-sticky-compare]');
      this.promo = this.dataset.promo === 'true';

      this.onVariantChange = this.onVariantChange.bind(this);
      document.addEventListener('variant:changed', this.onVariantChange);

      this.bindVisibility();
      this.bindButton();
      this.bindSwatches();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.onVariantChange);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.observer?.disconnect();
    }

    bindVisibility() {
      this.onScroll = () => this.updateVisibility();

      if (this.mainButton) {
        this.observer = new IntersectionObserver(() => this.updateVisibility(), {
          threshold: [0, 1],
        });
        this.observer.observe(this.mainButton);
      }

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.updateVisibility();
    }

    updateVisibility() {
      const atBottom =
        window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2;
      const rect = this.mainButton?.getBoundingClientRect();
      const mainButtonInView = rect
        ? rect.bottom > 0 && rect.top < window.innerHeight
        : true;

      this.classList.toggle('is-visible', !mainButtonInView && !atBottom);
    }

    bindButton() {
      if (!this.button || !this.mainButton) return;

      this.button.addEventListener('click', () => {
        this.mainButton.click();
      });

      const sync = () => {
        this.button.disabled = this.mainButton.disabled;
        this.button.classList.toggle('is-loading', this.mainButton.classList.contains('loading'));
      };

      new MutationObserver(sync).observe(this.mainButton, {
        attributes: true,
        attributeFilter: ['class', 'disabled'],
      });
    }

    bindSwatches() {
      this.querySelectorAll('.sticky-atc__swatch').forEach((swatch) => {
        swatch.addEventListener('click', () => {
          const index = swatch.dataset.optionIndex;
          this.querySelectorAll(`[data-option-index="${index}"]`).forEach((item) => {
            const selected = item === swatch;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });

          const input = document.querySelector(
            `variant-picker input[name="${CSS.escape(swatch.dataset.optionName)}"][value="${CSS.escape(swatch.dataset.optionValue)}"]`
          );
          input?.click();
        });
      });
    }

    onVariantChange(event) {
      const variant = event.detail?.variant;
      if (!variant) return;

      if (this.image && variant.featured_image) {
        this.image.src = variant.featured_image;
        this.image.srcset = '';
      }

      const labels = [];
      const seen = new Set();
      this.querySelectorAll('.sticky-atc__swatch').forEach((swatch) => {
        const index = swatch.dataset.optionIndex;
        const value = variant.options?.[Number(index)];
        const selected = swatch.dataset.optionValue === value;
        swatch.classList.toggle('is-selected', selected);
        swatch.setAttribute('aria-pressed', selected ? 'true' : 'false');

        if (!seen.has(index) && value) {
          seen.add(index);
          labels.push(String(value).toLowerCase());
        }
      });

      if (this.color) this.color.textContent = labels.join(' · ');
      this.updatePrice(variant);

      if (this.button) this.button.disabled = variant.available === false;
    }

    updatePrice(variant) {
      if (!this.price) return;

      const saleText = this.promo && variant.promo_sale_price
        ? variant.promo_sale_price
        : variant.price;
      const compareText = this.promo
        ? variant.promo_full_price
        : variant.compare_at_price;
      const cents = Number(variant.shopify_price || 0);
      const compareCents = Number(variant.shopify_compare_at_price || 0);
      const showCompare = this.promo
        ? Boolean(compareText)
        : compareCents > cents;

      if (saleText) this.price.textContent = saleText;

      if (!this.compare) return;
      if (showCompare && compareText) {
        this.compare.hidden = false;
        this.compare.textContent = compareText;
      } else {
        this.compare.hidden = true;
      }
    }
  }

  customElements.define('sticky-atc', StickyAtc);
}
